import React, { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import { useFormik } from 'formik';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import * as yup from 'yup';
import ContractLayout from './ContractLayout';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import UseFetchbyData from '../../../../Components/Hooks/UseFetchbyData';
import MobileServiceIndex from '../../../Mobile/ClientManage/Contract/MobileServiceIndex';
import NuDate from '../../../../Components/Utils/NuDate';



function Service() {
  const { clientViewId,contractsViewId,clientTickViewId } = useParams();
 
            
  const location = useLocation();
   const currentPage= location.state?.currentPage
   const searchQuery= location.state?.searchQuery
   const state = location.state;
 
            const [filter, setFilter] = useState(
                state?.approvalStatus || state?.category ? true : false
              );
                const [showFilterDialog, setShowFilterDialog] = useState(false);

                const { value: TicketType,getData:refTicketType } = useFetchMDIndex(
                  `/dropdown/dropdown-details/`,
                  "Ticket_Type",showFilterDialog
                );  
                
                const { value: Priority,getData:refPriority } = useFetchMDIndex(
                  `/dropdown/dropdown-details/`,
                  "Priority_Support_Tickets",showFilterDialog
                );  
                
                const { value: Status,getData:refStatus } = useFetchMDIndex(
                  `/dropdown/dropdown-details/`,
                  "Status_Support_Tickets",showFilterDialog
                ); 
                const [filterProps, setFilterProps] = useState({
              
                  status:"",
                  ticketType:"",
                  priority:"",
                });
              const [params, setParams] = useState({
             //    page: page,
             //    per_page: pageCount,
             //    search:searchQuery||"",
            
             status:"",
             ticketType:"",
             priority:"",
                approvalStatus:state?.approvalStatus? state.approvalStatus :"",
                category:state?.category? state.category :"",
              });
            
              const clearFilter = ()=> {
                setParams({...params,status:"", ticketType:"", priority:"",})
                formik.values.status=""
                formik.values.ticketType=""
                formik.values.priority=""
            
            
            
                  setFilter(false)
              }
            
              const formik = useFormik({
                enableReinitialize: true,
                initialValues: filterProps,
                validateOnChange: false,
                validateOnBlur: false,
                validationSchema: yup.object({
                  // email: yup.string().required('Email is required!'),
                }),
                onSubmit: async (value, { resetForm }) => {
                  setParams({...params,status:value.status, ticketType:value.ticketType, priority:value.priority, })
                  closeFilterDialog();
                  setFilter(true)
                  setFilterProps({
                    status:"",
                    ticketType:"",
                    priority:"",
                  });
                }
              })
              const closeFilterDialog = () => {
                 setShowFilterDialog(false);
               };

               const [screenSize, setScreenSize] = useState({
                                width: window.innerWidth,
                              });
                            
                              useEffect(() => {
                                const handleResize = () => {
                                  setScreenSize({
                                    width: window.innerWidth,
                                  });
                                };
                            
                                window.addEventListener("resize", handleResize);
                            
                                return () => {
                                  window.removeEventListener("resize", handleResize);
                                };
                              }, []);

               const { data,getData,dataLoading } = UseFetchbyData( `/tickets/contract/${contractsViewId}`,params);
               console.log(data,"contractcli");
   return (
     <>
     <ContractLayout 
      setFilterOpen={setShowFilterDialog}
           ClearFilter={clearFilter}
           newfilter={true}
           isFilter={filter}
           BackAccess={GetAccess("client_management_module")}
     
     >

       {
              screenSize.width < "768" ?(<>
              <div className=' w-full h-[calc(100vh-175px)] bg-white mt-1 rounded-lg shadow-lg overflow-hidden'>
              <MobileServiceIndex
              data={data}
              // // total={totalCount}
              // pageIndex={page}
              // setPageIndex={setPage}
              // dataCount={pageCount}
              // setDataCount={setPageCount}
              // officeId={officeId}
              getData={getData}
            
              />
              </div>
              </>):(<>
       <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
       <table className="min-w-full text-xs text-left">
         <thead>
           <tr className="text-black font-semibold  border-b border-gray-300">
             <th className="px-4 py-2 w-[8%]">Ref.</th>
            <th className="px-4 py-2 w-[17.4%]">Client</th>

            <th className="px-4 py-2 w-[17.4%]">Ticket Type</th>
            <th className="px-4 py-2 w-[17.4%]">Ticket Date</th>

            <th className="px-4 py-2 w-[17.4%]">Subject</th>

            {/* <th className="px-4 py-2 w-[15.83%]">Response Date</th> */}
            {/* <th className="px-4 py-2">Start Date</th>
            <th className="px-4 py-2">End Date</th> */}
            <th className="px-4 py-2 w-[17.4%]">Status</th>
            <th className="px-4 py-2 w-[5%]">Action</th>
           </tr>
         </thead>
         <tbody>
           {data.map((data) => (
             <tr key={data.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
                 <td className="px-4 py-2 w-[8%]">
                                                  <Link to={`/tickets/client-tickets/view/${data?.ticketId}`} >
                                            
                                            {data.refNumber}
                                                  </Link>
                                            
                                            </td>

               <td className="px-4 py-2 w-[17.4%]">
                                          <Link to={`/tickets/client-tickets/view/${data?.ticketId}`} >
                {data.clientName}
                </Link>
                </td>

                                          <td className="px-4 py-2 w-[17.4%]">
                                          <Link to={`/tickets/client-tickets/view/${data?.ticketId}`} >
                                            
                {data.ticketType}
                                            
                                            </Link>
                                            
                                            </td>

                                            <td className="px-4 py-2 w-[17.4%]">{data.createdAt? (
                                                                                   <NuDate
                                                                                     value={data?.createdAt}
                                                                                     format="DD-MMM-YYYY"
                                                                                   />
                                                                                 ) : (
                                                                                   "N/A"
                                                                                 )}</td>
               {/* <td className="px-4 py-2">{data.ref}</td> */}
               {/* <td className="px-4 py-2">{data.contract}</td> */}

               <td className="px-4 py-2 w-[17.4%]">{data.subject}</td>
                {/* <td className="px-4 py-2 w-[15.83%]">{data.date? (
                                                      <NuDate
                                                        value={data?.date}
                                                        format="DD-MMM-YYYY"
                                                      />
                                                    ) : (
                                                      "N/A"
                                                    )}</td> */}
               <td className="px-4 py-2 w-[17.4%]">
                 {data.status}
               </td>
               <td className="px-4 py-2 text-gray-500 w-[5%]">
                 <Link to={`/tickets/client-tickets/view/${clientTickViewId}`}
                                      state={{
                                        data: data,
                                        from: `/Contract-management/contracts/service/${contractsViewId}`,
                                      }}>
                                              <ViewIcon color="#048178" />

 </Link>
 </td>
             </tr>
           ))}
         </tbody>
       </table>
     </div>

    </>)}

     </ContractLayout>
 
 {showFilterDialog && (
     <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
       <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h2 className="text-xl mb-4">Filter </h2>
         <form onSubmit={formik.handleSubmit}>
           <div className="flex flex-col mb-4">
           <FormikSelectTwo
              label="Priority"
              Options={Priority}
              formik={formik}
              placeholder="Choose"
              name="priority"

              width="w-full"
              displayProperty={"Priority"}
              propertyName={"Priority_Support_Tickets"}
              getFunc={refPriority}

            /> 

<FormikSelectTwo
              label="Ticket Type"
              Options={TicketType}
              formik={formik}
              placeholder="Choose"
              name="ticketType"

              width="w-full"
              displayProperty={"Ticket Type"}
              propertyName={"Ticket_Type"}
              getFunc={refTicketType}

            /> 
           <FormikSelectTwo
              label="Status"
              Options={Status}
              formik={formik}
              placeholder="Choose"
              name="status"

              width="w-full"
              displayProperty={"Status"}
              propertyName={"Status_Support_Tickets"}
              getFunc={refStatus}
              
            />
           </div>
           <div className="flex justify-end gap-2">
             <CancelButton handleClick={closeFilterDialog} />
             <SubmitButton name="Apply" />
           </div>
         </form>
       </div>
     </div>
   )}
   </>
   )
}

export default Service